__turbopack_context__.v({
  "blueprintContainer": "_3IunSG_blueprintContainer",
  "bookCover": "_3IunSG_bookCover",
  "bookSize": "_3IunSG_bookSize",
  "coverBack": "_3IunSG_coverBack",
  "coverFront": "_3IunSG_coverFront",
  "coverTitle": "_3IunSG_coverTitle",
  "goldEmboss": "_3IunSG_goldEmboss",
  "paperBg": "_3IunSG_paperBg",
  "paperInnerSpine": "_3IunSG_paperInnerSpine",
  "perspectiveContainer": "_3IunSG_perspectiveContainer",
  "preserve3d": "_3IunSG_preserve3d",
  "spineShadow": "_3IunSG_spineShadow",
});
